export default __webpack_public_path__ + "static/media/SCA0010.34I-36516_-21476_0.abd566ba.jpg";